import { RouteObject } from 'react-router-dom';

import { ExternalLayout } from './ExternalLayout';
import { FolderActivity } from './FolderActivity/FolderActivity';
import { QrCodeActivity } from './QrCodeActivity/QrCodeActivity';



export const root: RouteObject = {
  path: 'external/:projectId',
  element: (<ExternalLayout />),
  children: [
    {
      path: 'folder/:folderId',
      element: (
        <FolderActivity />
      )
    },
    {
      path: 'share/:entityType/:entityId',
      element: (
        <QrCodeActivity />
      )
    }
  ]
};
